import { VideoProvider } from '@/constants'

export interface ParsedVideo {
  provider: VideoProvider
  id: string
}

// Every link shape the editor accepts. Keep in step with video-settings.component.ts, which
// warns the merchant about a link the portal could not play.
const YOUTUBE_PATTERNS = [
  /youtube\.com\/watch\?(?:.*&)?v=([\w-]{6,})/i,
  /youtu\.be\/([\w-]{6,})/i,
  /youtube\.com\/shorts\/([\w-]{6,})/i,
  /youtube\.com\/embed\/([\w-]{6,})/i,
]
const VIMEO_PATTERNS = [/vimeo\.com\/(?:video\/)?(\d{6,})/i, /player\.vimeo\.com\/video\/(\d{6,})/i]
// A direct, absolute http(s) link to a playable video file (Shopify CDN, self-hosted).
const FILE_PATTERN = /\.(mp4|webm|mov|m4v|ogg|ogv)(?:[?#]|$)/i

// Reads the video id for YouTube/Vimeo or keeps a direct file URL; undefined if unrecognized.
export function parseVideoUrl(url: string | undefined): ParsedVideo | undefined {
  if (!url || !url.trim()) {
    return undefined
  }
  const trimmed = url.trim()
  for (const pattern of YOUTUBE_PATTERNS) {
    const match = trimmed.match(pattern)
    if (match) {
      return { provider: VideoProvider.YouTube, id: match[1] }
    }
  }
  for (const pattern of VIMEO_PATTERNS) {
    const match = trimmed.match(pattern)
    if (match) {
      return { provider: VideoProvider.Vimeo, id: match[1] }
    }
  }
  if (/^https?:\/\//i.test(trimmed) && FILE_PATTERN.test(trimmed)) {
    return { provider: VideoProvider.File, id: trimmed }
  }
  return undefined
}
